// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"9632b12c","604":"9632b12c","609":"9632b12c","870":"9632b12c"}[chunkId] + ".chunk.css";
};